import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';
import { Monogram } from './Monogram';
export function Hero() {
  return <section className="relative pt-20 pb-8 md:pt-32 md:pb-20 lg:pt-40 lg:pb-28 bg-cream overflow-hidden" data-id="element-156">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-157">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-gold/5 blur-3xl" data-id="element-158" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-navy/5 blur-3xl" data-id="element-159" />
      </div>

      {/* Watermark logo background */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-0" data-id="element-160">
        <img src="https://cdn.magicpatterns.com/uploads/peDwgqSHFwNp4JGaXuMaPh/este_es_el_logo_esteee.png" alt="" aria-hidden="true" className="w-[90%] max-w-3xl object-contain opacity-[0.06]" data-id="element-161" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center mb-10" data-id="element-163">
          <div className="relative" data-id="element-164">
            <div className="absolute -inset-3 rounded-full bg-gradient-to-br from-gold via-gold-light to-gold-dark opacity-40 blur-2xl" data-id="element-165" />
            <div className="relative p-[3px] rounded-full bg-gradient-to-br from-gold-light via-gold to-gold-dark shadow-2xl" data-id="element-166">
              <div className="relative w-56 h-56 md:w-72 md:h-72 rounded-full overflow-hidden bg-navy" data-id="element-167">
                <img src="https://cdn.magicpatterns.com/uploads/f9M1CjBpbxLWErb7AsimCo/The_same_woman_from_3In4XrRUoB.png" alt="Anisley Estanque — Agente Licenciada" className="w-full h-full object-cover object-[center_15%]" data-id="element-168" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/50 via-transparent to-transparent" data-id="element-169" />
              </div>
            </div>
          </div>
          <p className="mt-6 text-navy/70 text-xs md:text-sm tracking-[0.4em] uppercase font-medium" data-id="element-170">
            Vida · Salud · Dental · Visión
          </p>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-navy leading-tight mb-6 text-balance" data-id="element-171">
          ¿Cuánto Vale La Tranquilidad De Saber Que Tu Familia Está Protegida...{' '}
          <span className="text-gold italic" data-id="element-172">Pase Lo Que Pase?</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-xl text-navy-light mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-173">
          La mayoría de las familias latinas en Estados Unidos están a{' '}
          <strong className="text-navy" data-id="element-174">UNA emergencia médica</strong> de perder
          todo lo que han construido. Esto es lo que nadie te está diciendo...
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-175">
          <a href="tel:786-374-5660" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white px-8 py-4 rounded-full font-medium text-lg transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-176">
            <Phone className="w-5 h-5 text-gold" data-id="element-177" />
            Llama Ahora
          </a>
          <a href="https://wa.me/17863745660" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white hover:bg-cream-dark text-navy border border-gold/30 px-8 py-4 rounded-full font-medium text-lg transition-all shadow-sm" data-id="element-178">
            <MessageCircle className="w-5 h-5 text-green-600" data-id="element-179" />
            WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}